import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import { v4 as uuidv4 } from "uuid";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import * as XLSX from "xlsx";
import CurrencyInput from "react-currency-input-field";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function EmbarquesCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_EMBARQUES = process.env.REACT_APP_URL_EMBARQUES;
  const URL_ARTICULOS_EMBARQUES = process.env.REACT_APP_URL_ARTICULOS_EMBARQUES;
  const URL_GASTOS_EMBARQUES = process.env.REACT_APP_URL_GASTOS_EMBARQUES;
  const URL_CONCEPTOS_GASTOS_EMBARQUES =
    process.env.REACT_APP_URL_CONCEPTOS_GASTOS_EMBARQUES;
  const URL_ARTICULOS_OC = process.env.REACT_APP_URL_ARTICULOS_OC;
  const URL_ARTICULOS_OC_ACUMULADOS = process.env.REACT_APP_URL_ARTICULOS_OC_ACUMULADOS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_NOTAS_CXP = process.env.REACT_APP_URL_NOTAS_CXP;
  const URL_ORDENES_COMPRA = process.env.REACT_APP_URL_ORDENES_COMPRA;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);
  const [fechaEmbarque, setFechaEmbarque] = useState(hoy);
  const [fechaEstimada, setFechaEstimada] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [total_cantidad, setTotalCantidad] = useState(0);
  const [tipoCambioUSDMXN, setTipoCambioUSDMXN] = useState(1);
  const [tipoCambioCNYUSD, setTipoCambioCNYUSD] = useState(1);

  const [articulosOC, setArticulosOC] = useState([]);
  const [lineasOC, setLineasOC] = useState([]); // renglones de OC (ArticulosOC) con su OC y proveedor
  const [OC, setOC] = useState([]);
  const [articulos, setArticulos] = useState([]);
  const [contenedor, setContenedor] = useState("");
  const [numeroInterno, setNumeroInterno] = useState("");
  const [kasher, setKasher] = useState("Taref");
  const [totalCaptura, setTotalCaptura] = useState(1);
  const [proveedores, setProveedores] = useState([]);
  const [proveedorOrden, setProveedorOrden] = useState("");
  const [selectedProveedor, setSelectedProveedor] = useState("");
  const [selectedProveedorNombre, setSelectedProveedorNombre] = useState("");
  const [moneda, setMoneda] = useState("");
  const [agrupado, setAgrupado] = useState([]);

  const [conceptosGastos, setConceptosGastos] = useState("");

  const classes = useStyles();
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      articulosOrden: "",
      articulos: "",
      cantidad: 0,
      pendEmbarcar: 0,
      piezasPorCaja: 0,
      CBM: 0,
      cajas: 0,
      cantidadOC: 0,
      costo: 0,
      costoUSD: 0,
      costoTotal: 0,
      proveedorOrden: "",
      moneda:"",
      OC:""
    },
  ]);

  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    axios
        .get(URL_ARTICULOS_OC_ACUMULADOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulosOC = res.data;
        setArticulosOC(allArticulosOC);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_ARTICULOS_OC, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        setLineasOC(res.data || []);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulos = res.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${URL_CONCEPTOS_GASTOS_EMBARQUES}Fijos`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allConceptosGastos = res.data;
        setConceptosGastos(allConceptosGastos);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
    .get(`${URL_PROVEEDORES}`, { 
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allProveedores = res.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });
      axios
      .get(URL_ORDENES_COMPRA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allOC = res.data;
        setOC(allOC);
      })
      .catch((err) => {
        console.log(err);
      });

  }, []);

  const saveEmbarqueNuevo = async (event) => {
    event.preventDefault();
    const excedidos = inputFields.filter((i) => i.articulos && parseFloat(i.cantidad) > parseFloat(i.pendEmbarcar));
    if (excedidos.length) {
      Swal.fire({ icon: "error", title: "Oops...", text: "Hay renglones que exceden lo pendiente de embarcar de su OC (en rojo)." });
      return;
    }
    Swal.fire({
      title: "Estas seguro?",
      text: "Se guardará el Embarque!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, guardar!",
    }).then(async (result) => {
    if (
      result.isConfirmed &&
      fechaEmbarque != "" &&
      fechaEstimada != "" &&
      contenedor != "" &&
      numeroInterno != "" &&
      inputFields.some((i) => i.articulos) &&
      observaciones != ""
    ) {
      setValidaBoton(false);
      toggleProgreso();
     
      let totalArticulos =
        inputFields.length + inputFields.length + conceptosGastos.length;
      let TCosto = inputFields.map((c) => parseFloat(c.costoTotal));
      let TTC = TCosto.reduce((t, total, index) => t + total, 0);
      try {
        await axios
          .post(
            URL_EMBARQUES,
            {
              fechaEmbarque,
              fechaEstimada,
              observaciones,
              contenedor,
              numeroInterno,
              kasher,
              total_cantidad,
              recibido: "No",
              total_costo: parseFloat(TTC).toFixed(2),
              saldo: parseFloat(TTC).toFixed(2),
              creado: user.id,
              proveedores: selectedProveedor,
              total_gasto: 0,
              tipoCambioUSDMXN,
              tipoCambioCNYUSD,
              tipo:"Importacion"
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((data) => {
            agrupado.map((b) => {
              axios
                .post(
                  `${URL_NOTAS_CXP}`,
                  {
                    proveedores: selectedProveedor,
                    embarques: data.data._id,
                    total_cantidad: b.cantidad,
                    total_costo: parseFloat(b.costoTotal).toFixed(2),
                    saldo: parseFloat(b.costoTotal).toFixed(2),
                    calidad:"No",
                    fecha:fechaEmbarque,
                    compraDirecta:"No"
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then((data2) => {
                  inputFields.map((a) => {
                    if (
                      a.articulos != "" &&
                      // a.cantidad != 0 &&
                      a.proveedorOrden == b.proveedorOrden
                    ) {
                      axios
                        .post(
                          `${URL_ARTICULOS_EMBARQUES}`,
                          {
                            articulosOC: a.articulosOrden,
                            articulos: a.articulos,
                            cantidad: a.cantidad,
                            CBM: a.CBM,
                            recibido: 0,
                            pendiente_recibir: a.cantidad,
                            embarques: data.data._id,
                            notasCxP: data2.data._id,
                            costo: a.costo,
                            total_costo: a.costoTotal,
                            proveedores: selectedProveedor,
                            faltante: 0,
                            danado: 0,
                            impuestos: 0,
                            revisarFaltante: 10,
                            revisarDanado: 10,
                            pedirFaltante: 0,
                            pedirDanado: 10,
                            faltanteTotal: 0,
                            danadoTotal: 0,
                            descuentoFaltante: 0,
                            descuentoDanado: 0,
                            descuentoTotal: 0,
                            familias: "NA",
                            sup: "NA",
                            observaciones:"NA",
                            calidad:"No",
                            costoUSD: a.costoUSD,
                            costoFactura: a.costoUSD
                          },
                          {
                            headers: {
                              Authorization: `Bearer: ${localStorage.getItem(
                                "app_token"
                              )}`,
                            },
                          }
                        )
                        .then(() => {
                          totalArticulos = totalArticulos - 1;
                          if (totalArticulos == 0) {
                            axios
                              .post(
                                URL_LOGS,
                                {
                                  tipo: "Crear Embarque",
                                  detalle: `Fecha Embarque ${fechaEmbarque} / Contenedor ${contenedor}`,
                                  user: user.id,
                                },
                                {
                                  headers: {
                                    Authorization: `Bearer: ${localStorage.getItem(
                                      "app_token"
                                    )}`,
                                  },
                                }
                              )
                              .then(() => {
                                Swal.fire(
                                  "Good job!",
                                  "Creado con exito",
                                  "success"
                                );
                                setTimeout(() => {
                                  window.location.reload();
                                }, 1000);
                              })
                              .catch((error) => {
                                Swal.fire({
                                  icon: "error",
                                  title: "Oops...",
                                  text: "Something went wrong!",
                                  footer: `${error.response.data}`,
                                });
                                console.log(error);
                                setValidaBoton(true);
                              });
                          }
                        })
                        .catch((error) => {
                          Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: "Something went wrong!",
                            footer: `${error.response.data}`,
                          });
                          console.log(error);
                          setValidaBoton(true);
                        });
                    } else {
                      totalArticulos = totalArticulos - 1;
                      if (totalArticulos == 0) {
                        axios
                          .post(
                            URL_LOGS,
                            {
                              tipo: "Crear Embarque",
                              detalle: `Fecha Embarque ${fechaEmbarque} / Contenedor ${contenedor}`,
                              user: user.id,
                            },
                            {
                              headers: {
                                Authorization: `Bearer: ${localStorage.getItem(
                                  "app_token"
                                )}`,
                              },
                            }
                          )
                          .then(() => {
                            Swal.fire(
                              "Good job!",
                              "Creado con exito",
                              "success"
                            );
                            setTimeout(() => {
                              window.location.reload();
                            }, 1000);
                          })
                          .catch((error) => {
                            Swal.fire({
                              icon: "error",
                              title: "Oops...",
                              text: "Something went wrong!",
                              footer: `${error.response.data}`,
                            });
                            console.log(error);
                            setValidaBoton(true);
                          });
                      }
                    }
                  });
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                  setValidaBoton(true);
                });

              // Acaba el primer map
            });

            // Lo embarcado se descuenta del renglon de su OC (y suma al embarcado de la OC) y del
            // acumulado del articulo. Los renglones sin articulo solo cuentan para terminar.
            const acumPorArticulo = {};
            articulosOC.forEach((ac) => {
              const art = (ac.articulos || [])[0];
              if (art) acumPorArticulo[art._id] = ac._id;
            });
            const headersToken = {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            };
            inputFields.map((w) => {
              const descontar = !w.articulosOrden
                ? Promise.resolve()
                : axios
                    .patch(
                      `${URL_ARTICULOS_OC}editEmbarcado/${w.articulosOrden}`,
                      { embarcado: parseFloat(w.cantidad) || 0, ordenesCompra: w.OC || undefined },
                      headersToken
                    )
                    .then(() =>
                      acumPorArticulo[w.articulos]
                        ? axios.patch(
                            `${URL_ARTICULOS_OC_ACUMULADOS}editEmbarcado/${acumPorArticulo[w.articulos]}`,
                            { embarcado: parseFloat(w.cantidad) || 0 },
                            headersToken
                          )
                        : null
                    );
              descontar
                .then(() => {
                  totalArticulos = totalArticulos - 1;
                  if (totalArticulos == 0) {
                    axios
                      .post(
                        URL_LOGS,
                        {
                          tipo: "Crear Embarque",
                          detalle: `Fecha Embarque ${fechaEmbarque} / Contenedor ${contenedor}`,
                          user: user.id,
                        },
                        {
                          headers: {
                            Authorization: `Bearer: ${localStorage.getItem(
                              "app_token"
                            )}`,
                          },
                        }
                      )
                      .then(() => {
                        Swal.fire("Good job!", "Creado con exito", "success");
                        setTimeout(() => {
                          window.location.reload();
                        }, 1000);
                      })
                      .catch((error) => {
                        Swal.fire({
                          icon: "error",
                          title: "Oops...",
                          text: "Something went wrong!",
                          footer: `${error.response.data}`,
                        });
                        console.log(error);
                        setValidaBoton(true);
                      });
                  }
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                  setValidaBoton(true);
                });
            });

            // Acaba el segundo map

            conceptosGastos.map((w) => {
              axios
                .post(
                  URL_GASTOS_EMBARQUES,
                  {
                    conceptosGastosEmbarques: w._id,
                    estimado: w.estimado,
                    real: w.estimado,
                    embarques: data.data._id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then(() => {
                  totalArticulos = totalArticulos - 1;
                  if (totalArticulos == 0) {
                    axios
                      .post(
                        URL_LOGS,
                        {
                          tipo: "Crear Embarque",
                          detalle: `Fecha Embarque ${fechaEmbarque} / Contenedor ${contenedor}`,
                          user: user.id,
                        },
                        {
                          headers: {
                            Authorization: `Bearer: ${localStorage.getItem(
                              "app_token"
                            )}`,
                          },
                        }
                      )
                      .then(() => {
                        Swal.fire("Good job!", "Creado con exito", "success");
                        setTimeout(() => {
                          window.location.reload();
                        }, 1000);
                      })
                      .catch((error) => {
                        Swal.fire({
                          icon: "error",
                          title: "Oops...",
                          text: "Something went wrong!",
                          footer: `${error.response.data}`,
                        });
                        console.log(error);
                        setValidaBoton(true);
                      });
                  }
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                  setValidaBoton(true);
                });
            });
          })
          // Catch primer then
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data.message}`,
            });
            console.log(error);
            setValidaBoton(true);
            setModalProgreso(false)
          });
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          // footer: `${error.response.data}`,
        });
        console.log(error);
        setValidaBoton(true);
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `Faltan Datos`,
      });
      setValidaBoton(true);
    }
  })
  };

  function BuscaProveedor(event) {
    const [id, moneda, nombre] = event.target.value.split(",");
    setSelectedProveedor(id || "")
    setSelectedProveedorNombre(nombre || "")
    setMoneda(moneda || "")
    setInputFields(
    [{
      id: uuidv4(),
      articulosOrden: "",
      articulos: "",
      cantidad: 0,
      pendEmbarcar: 0,
      CBM: 0,
      piezasPorCaja: 0,
      cajas: 0,
      cantidadOC: 0,
      costo: 0,
      costoUSD: 0,
      costoTotal: 0,
      proveedorOrden: id || "",
      OC:""
    }]
    );
    setTotalCantidad(0);
    setAgrupado([]);
  }

  // Lo que se puede embarcar: renglones de las OC del proveedor seleccionado con pendiente de embarcar
  // (OC activas y no cerradas; las Nacionales no se embarcan, se reciben en Recepciones)
  const lineasProveedor = lineasOC
    .filter((l) => {
      const oc = (l.ordenesCompra || [])[0];
      const art = (l.articulos || [])[0];
      const prov = oc && (oc.proveedores || [])[0];
      // el proveedor puede venir poblado (objeto) o solo como id, segun la version del back
      return (
        oc && art && prov &&
        selectedProveedor !== "" &&
        String(prov._id || prov) === String(selectedProveedor) &&
        l.is_active !== "No" &&
        oc.is_active !== "No" &&
        oc.status !== "Cerrado" &&
        oc.tipo !== "Nacional" &&
        parseFloat(l.pendiente_embarcar) > 0
      );
    })
    .sort((a, b) =>
      (a.ordenesCompra[0].idOrdenCompra || 0) - (b.ordenesCompra[0].idOrdenCompra || 0) ||
      (a.articulos[0].SKU > b.articulos[0].SKU ? 1 : -1)
    );

  // Renglon de la captura a partir de un renglon de OC (precio = el de la OC)
  function renglonDeLinea(l, cantidad) {
    const art = l.articulos[0];
    const ppc = parseFloat(art.piezasPorCaja) || 0;
    const pend = parseFloat(l.pendiente_embarcar) || 0;
    const cant = cantidad === undefined ? pend : cantidad;
    const precio = parseFloat(l.precio) || 0;
    return {
      articulosOrden: l._id,
      articulos: art._id,
      cantidad: cant,
      pendEmbarcar: pend,
      piezasPorCaja: ppc,
      cajas: ppc ? cant / ppc : 0,
      cantidadOC: l.cantidad,
      costo: precio,
      costoUSD: precio,
      costoTotal: cant * precio,
      proveedorOrden: selectedProveedor,
      OC: l.ordenesCompra[0]._id,
      kasherOC: l.ordenesCompra[0].kasher || "Taref",
    };
  }

  // K/T del embarque = el de sus OC: si todos los renglones son de OC Kasher (o todos Taref) se pone solo;
  // si se mezclan se queda lo que elijan y se avisa
  const kashersOC = [...new Set(inputFields.filter((i) => i.articulos && i.kasherOC).map((i) => i.kasherOC))];
  useEffect(() => {
    if (kashersOC.length === 1) setKasher(kashersOC[0]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [kashersOC.join("|")]);

//   function BuscaOC(id, event) {
//     console.log("hola2",event.target.value)
//     const newInputFields = articulosOC.map((a) => {
//       if (event.target.value === a._id) {
//         // if(a.ordenesCompra[0].moneda == "USD"){
//         return{
//         id : uuidv4(),
//         articulosOrden : a._id,
//         articulos : a.articulos[0]._id,
//         cantidad : a.pendiente_embarcar,
//         piezasPorCaja : a.articulos[0].piezasPorCaja,
//         cajas : a.cantidad / a.articulos[0].piezasPorCaja,
//         cantidadOC : a.cantidad,
//         costo : a.articulos[0].costoUSD,
//         costoUSD: a.articulos[0].costoUSD,
//         costoTotal: a.cantidad * a.articulos[0].costoUSD,
//         proveedorOrden : selectedProveedor,
//       }
//     // }else{
//     //   return{
//     //     id : uuidv4(),
//     //     articulosOrden : a._id,
//     //     articulos : a.articulos[0]._id,
//     //     cantidad : a.cantidad,
//     //     piezasPorCaja : a.articulos[0].piezasPorCaja,
//     //     cajas : a.cantidad / a.articulos[0].piezasPorCaja,
//     //     cantidadOC : a.cantidad,
//     //     costo : a.precio,
//     //     costoUSD: a.precio / tipoCambioCNYUSD,
//     //     costoTotal: a.cantidad * a.precio,
//     //     proveedorOrden : selectedProveedor,
//     //     moneda: a.ordenesCompra[0].moneda,
//     //     OC : event.target.value,
//     //   }
//     // }
//     }
//     })
//     .filter(function (el) {
//       return el != null;
//     });
//     setInputFields(newInputFields);

//     let cant = newInputFields.map((c) => parseFloat(c.cantidad));
//     let TC = cant.reduce((t, total, index) => t + total, 0);
//     setTotalCantidad(TC);

//     let agrupado = newInputFields.reduce(function (groups, item) {
//       const val = item["proveedorOrden"];
//       groups[val] = groups[val] || {
//         proveedorOrden: item.proveedorOrden,
//         costoTotal: 0,
//         cantidad: 0,
//       };
//       groups[val].proveedorOrden = item.proveedorOrden;
//       groups[val].costoTotal += item.costoTotal;
//       groups[val].cantidad += item.cantidad;
//       return groups;
//     }, []);
//     let temp = Object.values(agrupado)
//  setAgrupado(temp)
//   }

  function BuscaArticulo(id, event) {
    const l = lineasOC.find((x) => x._id === event.target.value);
    const vacio = {
      articulosOrden: "", articulos: "", cantidad: 0, pendEmbarcar: 0, piezasPorCaja: 0, cajas: 0,
      cantidadOC: 0, costo: 0, costoUSD: 0, costoTotal: 0, proveedorOrden: selectedProveedor, OC: "",
    };
    handleChangeInputArticulo(id, l ? renglonDeLinea(l) : vacio);
  }

  const handleChangeInputArticulo = (id, datos) => {
    const newInputFields = inputFields.map((i) => (id === i.id ? { ...i, ...datos } : i));
    setInputFields(newInputFields);
    ActualizaTotales(newInputFields);
  };

  const handleAddFields = () => {
    let TC = totalCaptura + 1;

    setTotalCaptura(TC);
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        articulosOrden: "",
        articulos: "",
        cantidad: 0,
        pendEmbarcar: 0,
        CBM: 0,
        piezasPorCaja: 0,
        cajas: 0,
        cantidadOC: 0,
        costo: 0,
        costoUSD: 0,
        costoTotal: 0,
        proveedorOrden: selectedProveedor,
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    ActualizaTotales(values);
  };

  const handleChangeInputCosto = (value, name, id) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[name] = value;
        i.costoUSD = value;
        let totalParcial = i.cantidad * value
        i.costoTotal = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };


  // Solo renglones con articulo: uno vacio agruparia aparte y crearia una nota CxP en 0
  function ActualizaTotales(campos = inputFields) {
    const conArticulo = campos.filter((c) => c.articulos);
    let cant = conArticulo.map((c) => parseFloat(c.cantidad) || 0);
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TC);

    let agrupado = conArticulo.reduce(function (groups, item) {
      const val = item["proveedorOrden"];
      groups[val] = groups[val] || {
        proveedorOrden: item.proveedorOrden,
        costoTotal: 0,
        cantidad: 0,
      };
      groups[val].proveedorOrden = item.proveedorOrden;
      groups[val].costoTotal += parseFloat(item.costoTotal) || 0;
      groups[val].cantidad += parseFloat(item.cantidad) || 0;
      return groups;
    }, []);
    let temp = Object.values(agrupado)
 setAgrupado(temp)
  }

  // Verificar cantidad
  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.CBM = parseFloat(event.target.value);
      }
      return i;
    });
    setInputFields(newInputFields);
  };

  const handleChangeInputCantidad = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        if(event.target.value <= i.pendEmbarcar || event.target.value == "") {
        i[event.target.name] = parseFloat(event.target.value);
        i.cajas = parseFloat(event.target.value) / parseFloat(i.piezasPorCaja);
        i.costoTotal = parseFloat(event.target.value) * parseFloat(i.costoUSD);
        }else{
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "La cantidad excede el pendiente embarcar!",
          });
          i[event.target.name] = 0
          i.cajas = 0
        }
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputCantidadCajas = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        if(parseFloat(event.target.value) * parseFloat(i.piezasPorCaja) <= i.pendEmbarcar || event.target.value == "") {
          let cantTemp =
          parseFloat(event.target.value) * parseFloat(i.piezasPorCaja);
        i[event.target.name] = event.target.value;
        i.cantidad =
          parseFloat(event.target.value) * parseFloat(i.piezasPorCaja);
        i.costoTotal =
          parseFloat(event.target.value) *
          parseFloat(i.piezasPorCaja) *
          parseFloat(i.costoUSD);
        }else{
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "La cantidad excede el pendiente embarcar!",
          });
          i[event.target.name] = 0
          i.cantidad = 0
        }
       
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  // Migracion
  //   function importarArchivo(event){
  //   const target = event.target;
  //   const value = target.type === "checkbox" ? target.checked : target.value;
  //   const name = target.name;
  //   let hojas = [];
   
  //   if (name === "file") {
  
  //     let reader = new FileReader();
  //       reader.readAsArrayBuffer(target.files[0]);
  //       reader.onloadend = (e) => {
  //         var data = new Uint8Array(e.target.result);
  //         var workbook = XLSX.read(data, { type: "array" });
  
  //         workbook.SheetNames.forEach(function (sheetName) {
  //           // Here is your object
  //           var XL_row_object = XLSX.utils.sheet_to_json(
  //             workbook.Sheets[sheetName]
  //           );
  //           hojas.push({
  //             data: XL_row_object,
  //             sheetName,
  //           });
  //         });
  
  //         let A1 = hojas[0].data
  
  //         let TC = totalCaptura
  //         A1.map((a)=>{
  //            TC = TC + 1
  //           setTotalCaptura(TC)
  //         inputFields.push({
  //           id: uuidv4(),
  //           articulosOrden: a.articulosOrden,
  //           articulos: a.articulos,
  //           cantidad: a.cantidad,
  //           pendEmbarcar: a.pendiente_embarcar,
  //           piezasPorCaja: 0,
  //           CBM:0,
  //           cajas: 0,
  //           cantidadOC: 0,
  //           costo: 0,
  //           costoUSD: 0,
  //           moneda:"USD",
  //           costoTotal: 0,
  //           proveedorOrden: "6643bc1e134da5001c2765d5",
  //           OC: "67c3e50237778014294883ab"
  //         })
  //         })
  
  //         ActualizaTotales()
  //       }
  //   }
  // }
  // console.log("hola", inputFields)

  function importarArchivo(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    let hojas = [];

    if (name === "file") {
      if (!selectedProveedor) {
        Swal.fire({ icon: "warning", title: "Selecciona primero el proveedor", text: "Los SKU se buscan en sus órdenes de compra." });
        target.value = "";
        return;
      }
      let reader = new FileReader();
      reader.readAsArrayBuffer(target.files[0]);
      reader.onloadend = (e) => {
        var data = new Uint8Array(e.target.result);
        var workbook = XLSX.read(data, { type: "array" });

        workbook.SheetNames.forEach(function (sheetName) {
          // Here is your object
          var XL_row_object = XLSX.utils.sheet_to_json(
            workbook.Sheets[sheetName]
          );
          hojas.push({
            data: XL_row_object,
            sheetName,
          });
        });

        let A1 = hojas[0].data;

        // SKU -> renglon de OC del proveedor seleccionado (si esta en varias OC, la mas antigua)
        const articulosMap = {};
        lineasProveedor.forEach((l) => {
          const sku = String(l.articulos[0].SKU).trim();
          if (!articulosMap[sku]) articulosMap[sku] = l;
        });

        const articulosNoEncontrados = [];
        const articulosCantidadExcedida = [];
        const nuevos = [];

        // Iterar sobre A1 una sola vez
        for (const a of A1) {
          const linea = articulosMap[String(a.SKU || "").trim()];
          if (linea) {
            const cantidad = parseFloat(a.cantidad) || 0;
            if (cantidad > linea.pendiente_embarcar) {
              articulosCantidadExcedida.push(
                `${a.SKU} (cantidad: ${cantidad}, pendiente: ${linea.pendiente_embarcar})`
              );
            }
            const r = renglonDeLinea(linea, cantidad);
            // costo del Excel si viene; si no, el de la OC
            const costo = a.costo === undefined || a.costo === "" ? r.costo : parseFloat(a.costo) || 0;
            nuevos.push({
              id: uuidv4(),
              ...r,
              costo,
              costoUSD: costo,
              costoTotal: costo * cantidad,
              CBM: parseFloat(a.CBM) || 0,
            });
          } else {
            // Si no se encuentra el artículo, agregarlo a la lista de no encontrados
              articulosNoEncontrados.push(a.SKU);
          }
        }
        const campos = [...inputFields.filter((i) => i.articulos), ...nuevos];
        if (campos.length) {
          setInputFields(campos);
          ActualizaTotales(campos);
        }

        // Verificar si se encontraron artículos que no estaban en el mapa
        if (articulosNoEncontrados.length > 0) {
          const mensaje = `Los siguientes SKU no tienen pendiente de embarcar en las OC de ${selectedProveedorNombre}: ${articulosNoEncontrados.join(
            ", "
          )}`;
          Swal.fire({
            title: "Artículos no encontrados",
            text: mensaje,
            icon: "warning",
            button: "Entendido",
          });
        }

        if (articulosCantidadExcedida.length > 0) {
          const mensaje = `Las siguientes líneas exceden la cantidad pendiente por embarcar:\n\n${articulosCantidadExcedida.join(
            "\n"
          )}`;
          Swal.fire({
            title: "Cantidades excedidas",
            text: mensaje,
            icon: "error",
            button: "Revisar",
          });
        }
        target.value = "";
      };
    }
  }


  return (
    <>
      <Header />
      <br />
      <br />
      {user.embarques ? (
        <div className="card container col-10">
          <h3 align="center">Nuevo Embarque</h3>
          <Form onSubmit={saveEmbarqueNuevo}>
            <Row>
              <Col md={2}>
                <Label>Fecha Embarque</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fechaEmbarque}
                  required
                  onChange={(e) => {
                    setFechaEmbarque(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <Label>Selecciona Proveedor</Label>
                <Input
                  name="proveedor"
                  type="select"
                  value={selectedProveedor ? `${selectedProveedor},${moneda},${selectedProveedorNombre}` : ""}
                  // required
                  onChange={(event) => {
                    BuscaProveedor(event);
                  }}
                >
                  <option value="">Selecciona un Proveedor</option>
                  {proveedores
                    .sort((a, b) =>
                      a.nombre_comercial > b.nombre_comercial ? 1 : -1
                    )
                    .map((a) => {
                      return (
                        <option
                          value={`${a._id},${a.moneda},${a.nombre_comercial}`}
                        >
                          {a.nombre_comercial}
                        </option>
                      );
                    })}
                </Input>
              </Col>
              {/*<Col md={2}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Proveedor
                </Label>
                <Input
                  type="text"
                  placeholder="proveedor"
                  value={selectedProveedorNombre}
                  disabled
                />
              </Col>*/}
              <Col md={2}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Moneda
                </Label>
                <Input
                  type="text"
                  placeholder="Moneda"
                  value={moneda}
                  disabled
                />
              </Col>
              <Col md={4}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="text"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={2}>
                <Label># Contenedor</Label>
                <Input
                  type="text"
                  placeholder="contenedor"
                  value={contenedor}
                  required
                  onChange={(e) => {
                    setContenedor(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <Label>Numero Interno</Label>
                <Input
                  type="text"
                  placeholder="Numero Interno"
                  value={numeroInterno}
                  required
                  onChange={(e) => {
                    setNumeroInterno(e.target.value);
                  }}
                />
              </Col>

              <Col md={2}>
                <Label>K / T</Label>
                <Input
                  type="select"
                  value={kasher}
                  required
                  onChange={(e) => {
                    setKasher(e.target.value);
                  }}
                >
                  <option value="Taref">T</option>
                  <option value="Kasher">K</option>
                </Input>
                {kashersOC.length > 1 && (
                  <small style={{ color: "#b45309" }}>Hay OC Kasher y Taref en este embarque</small>
                )}
              </Col>

              <Col md={2}>
                <Label>Fecha Estimada de Arribo</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fechaEstimada}
                  required
                  onChange={(e) => {
                    setFechaEstimada(e.target.value);
                  }}
                />
              </Col>
              {/* <Col md={2}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Tipo Cambio CNY USD
                </Label>
                <Input
                  type="number"
                  placeholder="tipoCambioCNYUSD"
                  value={tipoCambioCNYUSD}
                  required
                  onChange={(e) => {
                    setTipoCambioCNYUSD(e.target.value);
                    const newInputFields = inputFields.map((i) => {
                      if (moneda == "CNY") {
                        i.costo = i.costo;
                        i.costoUSD = i.costo / e.target.value;
                        i.costoTotal =
                          parseFloat(i.costo / e.target.value) *
                          parseFloat(i.cantidad);
                      }
                      return i;
                    });
                    setInputFields(newInputFields);
                    ActualizaTotales();
                  }}
                />
              </Col> */}
              <Col md={2}>
                <Label for="exampleEmail" className="mr-sm-2">
                  TIpo Cambio USD MXN
                </Label>
                <Input
                  type="number"
                  placeholder="tipoCambioUSDMXN"
                  value={tipoCambioUSDMXN}
                  required
                  onChange={(e) => {
                    setTipoCambioUSDMXN(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <h4 id="logoutBoton">
                  TOTALES{" "}
                  {new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(total_cantidad)} pzas.
                </h4>
              </Col>
            </Row>

            <Row>
              <Col>
                <Input
                  // required
                  type="file"
                  name="file"
                  id="file"
                  onChange={(event) => importarArchivo(event)}
                />
              </Col>
            </Row>

            {/* Tabla Articulos */}

            <Row>
              <Col md={4}>
                <Label className="mr-sm-2">Articulo</Label>
              </Col>

              <Col md={1}>
                <Label className="mr-sm-2">Pend Embarcar</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Costo</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Cajas</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Pzas por Caja</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Cantidad</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">CBM</Label>
              </Col>
            </Row>

            {inputFields.map((inputField) => (
              <div key={inputField.id}>
                <Row
                  style={
                    inputField.cantidad > inputField.pendEmbarcar
                      ? { backgroundColor: "#ed8c8c" }
                      : null
                  }
                >
                  <Col md={4}>
                    <Input
                      // bsSize="sm"
                      name="orden"
                      type="select"
                      value={inputField.articulosOrden}
                      onChange={(event) => {
                        BuscaArticulo(inputField.id, event);
                      }}
                    >
                      <option value="">
                        {!selectedProveedor
                          ? "Selecciona primero el proveedor"
                          : lineasProveedor.length
                          ? "Selecciona"
                          : "Sin pendiente de embarcar en sus OC"}
                      </option>
                      {lineasProveedor
                        .filter(
                          (l) =>
                            l._id === inputField.articulosOrden ||
                            !inputFields.some((f) => f.articulosOrden === l._id)
                        )
                        .map((l) => (
                          <option key={l._id} value={l._id}>
                            OC {l.ordenesCompra[0].idOrdenCompra} · {l.articulos[0].SKU} {l.articulos[0].nombre} (pend. {l.pendiente_embarcar})
                          </option>
                        ))}
                    </Input>
                  </Col>
                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="pendEmbarcar"
                      type="number"
                      min="0"
                      step="any"
                      value={inputField.pendEmbarcar}
                      disabled
                    />
                  </Col>
                  <Col md={1}>
                    <CurrencyInput
                      intlConfig={{ locale: "en-US", currency: "USD" }}
                      prefix="$"
                      name="costo"
                      defaultValue={0}
                      decimalsLimit={2}
                      value={inputField.costo}
                      className="form-control form-control-md2"
                      style={{ width: "100%", padding: "0.25rem 0.5rem" }}
                      onValueChange={(value, name) =>
                        handleChangeInputCosto(value, name, inputField.id)
                      }
                    />
                  </Col>

                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="cajas"
                      type="number"
                      min="0"
                      step="any"
                      value={inputField.cajas}
                      onChange={(event) =>
                        handleChangeInputCantidadCajas(inputField.id, event)
                      }
                    />
                  </Col>

                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="piezasPorCaja"
                      type="string"
                      value={inputField.piezasPorCaja}
                      disabled
                    />
                  </Col>

                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="cantidad"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Cantidad"
                      value={inputField.cantidad}
                      onChange={(event) =>
                        handleChangeInputCantidad(inputField.id, event)
                      }
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="CBM"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="CBM"
                      value={inputField.CBM}
                      onChange={(event) =>
                        handleChangeInput(inputField.id, event)
                      }
                    />
                  </Col>
                  <Col>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={inputFields.length === 1}
                      onClick={() => handleRemoveFields(inputField.id)}
                      tabindex="-1"
                    >
                      <i class="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFields}
                      tabindex="-1"
                    >
                      <i class="fas fa-plus"></i>
                    </Button>
                  </Col>
                </Row>
              </div>
            ))}
            <Row>
              <Col md={12}>
                <h4 id="logoutBoton">
                  TOTALES{" "}
                  {new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(total_cantidad)} pzas.
                </h4>
              </Col>
            </Row>
            {/* Termina Tabla Articulos */}

            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <Button
              href="/ListadoEmbarques"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Form>
          <br />
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default EmbarquesCreate;
